
import { Component, Prop, Vue } from 'vue-property-decorator';
import BaseComponent from '@/author/components/BaseComponent.vue';
import KnowledgeCheckEvents from '@/author/components/KnowledgeCheckParts/KnowledgeCheckEvents.vue';
import {KNOWLEDGE_CHECK_EVENTS} from '@/author/constants';
import store from '@/store';
import { AppModule } from '@/store/modules/app';
import { getModule } from 'vuex-module-decorators';
import Timer from 'easytimer.js';
const AppState = getModule(AppModule, store);
@Component
export default class FreeText extends BaseComponent {
    @Prop() feedbackTitle?: string;
    @Prop() feedbackDescription?: string;
    @Prop() title?: string;
    @Prop() instructions?: string;
    @Prop() submitLabel?: string;
    isInteractive :boolean = true;
    sessionTimer : Timer = new Timer();

    submited = false;
    questions:any= {}
    feedbackData = []
    created(){
      this.lockForward();
      KnowledgeCheckEvents.$on(KNOWLEDGE_CHECK_EVENTS.MOUNTED, this.registerFreeTextElement);
    }
    mounted(){
      KnowledgeCheckEvents.$on(KNOWLEDGE_CHECK_EVENTS.OPTION_SELECTED, this.registerFreeTextElement);
      this.sessionTimer.start();
    }
    beforeDestroy(){
      KnowledgeCheckEvents.$off([KNOWLEDGE_CHECK_EVENTS.OPTION_SELECTED, KNOWLEDGE_CHECK_EVENTS.MOUNTED]);
    }
    registerFreeTextElement(freeTextData:any){
      this.$set(this.questions, freeTextData.uid, freeTextData);
    }
    canSubmit(){
      return Object.keys(this.questions).map(key=>this.questions[key]).every(freetext => !!freetext.userAnswer);
    }
    generateFeedbackData(){
      let questions = Object.keys(this.questions);
      let result:any = {};
      for (var x =0; x <= questions.length -1; x++){
        let question = this.questions[questions[x]];
        if(result.hasOwnProperty(question.groupTitle))
          result[question.groupTitle].questions.push(question);
        else 
          result[question.groupTitle] = {groupTitle: question.groupTitle, groupDescription: question.groupDescription,color: question.color, questions:[question]};
            
      }
      return result;
    }
    showFeedback(){
      this.feedbackData = this.generateFeedbackData();
      this.submited = true;
      this.unlock();
      this.sessionTimer.reset();
    }
}
